/*
  PARA Recycling - Theme JavaScript
  Grundsatz: Das Skript ist eine reine Verbesserung (progressive enhancement).
  Jeder Teilbereich ist einzeln abgesichert. Schlaegt ein Bereich fehl, bleibt
  die Seite vollstaendig sichtbar und bedienbar. Es wird niemals Inhalt
  ausgeblendet, bevor der Mechanismus zum Wiedereinblenden bereitsteht.
*/
(function () {
  'use strict';

  function safe(fn) {
    try {
      fn();
    } catch (e) {
      if (window.console && window.console.warn) {
        window.console.warn('[PARA theme]', e);
      }
    }
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  safe(function () {
    document.documentElement.classList.remove('no-js');
  });

  // Header-Hoehe als CSS-Variable (fuer scroll-margin der Anker)
  safe(function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    function setHeaderHeightVar() {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    }
    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);

    function onScroll() {
      if (window.scrollY > 8) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  // Mobiles Menue
  safe(function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !mobileNav) return;

    function closeNav() {
      mobileNav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    var mobileLinks = mobileNav.querySelectorAll('a');
    for (var i = 0; i < mobileLinks.length; i++) {
      mobileLinks[i].addEventListener('click', closeNav);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeNav();
        toggle.focus();
      }
    });
  });

  // Dezentes Einblenden beim Scrollen.
  // Wichtig: Elemente werden erst ausgeblendet, nachdem der Observer
  // erfolgreich erstellt wurde. Schlaegt irgendetwas fehl, werden alle
  // Elemente sofort wieder sichtbar gemacht.
  safe(function () {
    if (prefersReducedMotion()) return;
    if (!('IntersectionObserver' in window)) return;

    var selector = [
      '.stat-primary', '.about-point', '.process-node', '.product-featured',
      '.product-list__item', '.partner-row', '.feature-item', '.outcome-item',
      '.careers-field'
    ].join(', ');

    var targets = document.querySelectorAll(selector);
    if (!targets.length) return;

    function reveal(el) {
      el.style.opacity = '';
      el.style.transform = '';
    }

    var observer;
    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
    } catch (e) {
      return; // Kein Ausblenden stattgefunden - Seite bleibt unveraendert sichtbar.
    }

    // Sicherheitsnetz: falls der Observer aus irgendeinem Grund nicht ausloest,
    // wird nach 3 Sekunden alles zwangsweise sichtbar gemacht.
    var fallbackTimer = window.setTimeout(function () {
      for (var i = 0; i < targets.length; i++) {
        reveal(targets[i]);
      }
    }, 3000);

    window.addEventListener('beforeunload', function () {
      window.clearTimeout(fallbackTimer);
    });

    for (var i = 0; i < targets.length; i++) {
      targets[i].style.transition = 'opacity .5s ease, transform .5s ease';
      targets[i].style.opacity = '0';
      targets[i].style.transform = 'translateY(10px)';
      observer.observe(targets[i]);
    }
  });
})();
